import { useEffect } from "react";

import { useLocation } from "react-router-dom";
import { MARKET_SLUG } from "app/constants";
import { useAppDialog } from "app/utils";

export default function GlobalDialogs() {
    const { open, isOpen: appDialogIsOpen } = useAppDialog();
    const location = useLocation();

    useEffect(() => {
        // if the dialog is already open, don't open it again
        if (appDialogIsOpen) return;

        // skip query on market page due to conflicting dialogs
        if (location.pathname.includes(MARKET_SLUG + "/")) return;
        return;
    }, [location.pathname, open, appDialogIsOpen]);

    return null;
}
